import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";


const ProngOven = ({ data, setProngOven }) => {
  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">PRONG OVEN PROCESS SHEET</div>
          <div
            onClick={() => setProngOven(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Batch no.</TableCell>
                  <TableCell>Quantity (Nos)</TableCell>
                  <TableCell>Min Temp(°C)</TableCell>
                  <TableCell>Max Temp(°C)</TableCell>
                  <TableCell>Total Cycle Time (Hr)</TableCell>
                  <TableCell>Cycle Start Date</TableCell>
                  <TableCell>Cycle Start Time</TableCell>
                  <TableCell>Operator</TableCell>
                  <TableCell>Cycle End Date</TableCell>
                  <TableCell>Cycle End Time</TableCell>
                  <TableCell>Supervisor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {data?.map((e) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {e.batch_type ? e.batch_type : "--"}
                      </TableCell>
                      <TableCell>{e.quantity ? e.quantity : "--"}</TableCell>
                      <TableCell>{e.min_temp ? e.min_temp : "--"}</TableCell>
                      <TableCell>{e.max_temp ? e.max_temp : "--"}</TableCell>

                      <TableCell>
                        {e.cycle_time_hours ? e.cycle_time_hours : "--"}
                      </TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("YYYY-MM-DD")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("YYYY-MM-DD")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>

                      <TableCell>
                        {e.supervisor ? e.supervisor : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div className="modal-overlay" onClick={() => setProngOven(false)}></div>
    </>
  );
};

export default ProngOven;
